import { Upload } from 'lucide-react';

interface ChatDropOverlayProps {
  visible: boolean;
  remainingSlots: number;
}

export function ChatDropOverlay({ visible, remainingSlots }: ChatDropOverlayProps) {
  if (!visible) return null;
  const slotLabel =
    remainingSlots <= 0
      ? 'Attachment limit reached'
      : `${remainingSlots} slot${remainingSlots === 1 ? '' : 's'} remaining`;

  return (
    <div className="absolute inset-0 z-40 flex items-center justify-center bg-paper/80 backdrop-blur-sm pointer-events-none">
      <div className="flex flex-col items-center gap-2 px-8 py-6 rounded-xl border-2 border-dashed border-info bg-info-surface">
        <Upload className="w-6 h-6 text-info" />
        <p className="text-sm font-semibold text-info">Drop files to attach</p>
        <p className="text-xs text-surface-600">Up to 5 files · PDF, CSV, images</p>
        <p className="text-xs text-surface-500 font-mono">{slotLabel}</p>
      </div>
    </div>
  );
}
